/**
 * 공지 테이블 미리보기용: HTML·이스케이프된 태그·마크다운 볼드 등을 제거하고 한 줄짜리 평문만 남김.
 */
export function stripNoticeContentPreview(
  raw: string | null | undefined,
): string {
  if (raw == null || raw === "") return "";

  let s = String(raw);

  s = s
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/gi, " ");

  s = s.replace(/<[^>]*>/g, "");

  s = s.replace(/\*\*([^*]+)\*\*/g, "$1");
  s = s.replace(/__([^_]+)__/g, "$1");
  s = s.replace(/\*\*/g, "");
  s = s.replace(/__/g, "");

  s = s.replace(/\s+/g, " ").trim();
  return s;
}
